import type { PropTypes } from './Article.types';
import type { ReactElement } from 'react';

import { Box, Card, Flex, Text } from '@rango-dev/whale';
import React from 'react';
import Markdown from 'react-markdown';

import styles from './Article.module.css';

export function Article(props: PropTypes): ReactElement {
  const { dynamicArticle } = props;
  const { title, body } = dynamicArticle;

  return (
    <Card variant="surface" className={styles.container}>
      <Box px={{ initial: '4', md: '65px' }} py={{ initial: '5', md: '65px' }}>
        <Flex
          direction="column"
          position="relative"
          maxWidth="894px"
          mx="auto"
          className={styles.content}>
          <Text as="div" className={styles.title}>
            {title}
          </Text>
          <Markdown>{body}</Markdown>
        </Flex>
      </Box>
    </Card>
  );
}
